import React from "react";
// import { Chart as ChartJS, Filler, registerables } from "chart.js";
// import { Chart } from "react-chartjs-2";
// import styles from "./FunnelChartCard.module.css";

// ChartJS.register(...registerables, Filler);

// TODO: chart library TBD — commenting out chart rendering until we decide on the right charts
const FunnelChartCard = ({ title, subtitle, config }) => {  // eslint-disable-line no-unused-vars
  return null;
};

export default FunnelChartCard;
